import { Link } from '@pega/cosmos-react-core';

export const defaultStageNames = [
  'Initiate',
  'Identify customer',
  'Eligibility',
  'Intake',
  'Process requests',
  'Merge'
];

export const createStages = (stageNames: string[], current: number) => {
  const now = new Date();
  return stageNames.map((stageName, i) => {
    const stageDate = new Date(now);
    const completed = i + 1 < current;
    if (completed) stageDate.setDate(now.getDate() + i - current);
    return {
      name: stageName,
      id: `stage-${i + 1}`,
      date: completed || i + 1 === current ? stageDate : undefined,
      completed
    };
  });
};

export const getSteps = (currentStageIndex: number, stageIndex: number) => {
  return [
    'First step',
    'Second step that contains much more text to demonstrate overflow handling',
    <Link href='https://www.pega.com' target='_blank'>
      Steps can be links as well
    </Link>
  ].map((step, i) => {
    return {
      name: step,
      completed: stageIndex < currentStageIndex || (stageIndex === currentStageIndex && i === 0),
      id: `step-${i + 1}`
    };
  });
};
